import { Box, Stack, Typography } from '@mui/material'
import labelStyles from '@/components/Settings/settingsRowLabelBlock.module.scss'
import cardStyles from '@/components/Settings/SettingsRowCard.module.scss'

/**
 * @param {{
 *   value?: string | number,
 *   label: string,
 *   caption: string,
 *   LabelIcon?: import('react').ComponentType,
 *   kpiDescription?: boolean,
 * }} props
 */
export function SettingsRowCardBody({ value, label, caption, LabelIcon, kpiDescription = false }) {
  const valueStr = value != null && value !== '' ? String(value) : null
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={0} className={cardStyles.cardLabelRow}>
        {LabelIcon ? (
          <Box component="span" className={labelStyles.iconWrap} aria-hidden>
            <LabelIcon />
          </Box>
        ) : null}
        <Typography component="p" variant="subtitle2" className={labelStyles.title}>
          {label}
        </Typography>
      </Stack>
      {valueStr ? (
        <Typography component="p" color="text.primary" className={cardStyles.metricValue}>
          {valueStr}
        </Typography>
      ) : null}
      <Typography
        variant="body2"
        component="p"
        className={`${labelStyles.description} ${valueStr ? labelStyles.descriptionAfterValue : ''} ${kpiDescription ? labelStyles.descriptionKpi : ''}`}
      >
        {caption}
      </Typography>
    </>
  )
}
